import React from 'react';
/**
 * Generation compatibility overview table.
 * Self-contained — owns its own table markup.
 */
export function CompatibilityTable() {
  return <div className="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden mb-16" data-id="element-224">
      <div className="p-6 bg-gray-900 text-white" data-id="element-225">
        <h3 className="text-xl font-bold uppercase tracking-wide" data-id="element-226">
          Generation Compatibility Overview
        </h3>
      </div>
      <div className="overflow-x-auto" data-id="element-227">
        <table className="w-full text-left border-collapse" data-id="element-228">
          <thead data-id="element-229">
            <tr className="bg-gray-50 border-b border-gray-200" data-id="element-230">
              <th className="p-4 font-bold text-gray-900 w-1/3" data-id="element-231">Product</th>
              <th className="p-4 font-bold text-gray-900 w-1/6" data-id="element-232">Generation</th>
              <th className="p-4 font-bold text-gray-900 w-1/4" data-id="element-233">Best Use</th>
              <th className="p-4 font-bold text-gray-900" data-id="element-234">
                Compatibility Notes
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200" data-id="element-235">
            <tr className="hover:bg-blue-50/50 transition-colors" data-id="element-236">
              <td className="p-4 font-bold text-blue-700" data-id="element-237">
                Gen 3 WT Sensor Sock
              </td>
              <td className="p-4" data-id="element-238">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800" data-id="element-239">
                  Gen 3
                </span>
              </td>
              <td className="p-4 text-gray-700" data-id="element-240">Current Gen 3 setups</td>
              <td className="p-4 text-sm text-gray-600" data-id="element-241">
                <strong className="text-gray-900" data-id="element-242">
                  Requires Gen 3 E-Hogu.
                </strong>{' '}
                The newest generation designed specifically for the Gen 3
                scoring ecosystem.
              </td>
            </tr>
            <tr className="hover:bg-gray-50 transition-colors" data-id="element-243">
              <td className="p-4 font-bold text-gray-900" data-id="element-244">
                Gen 2 WT Sensor Sock
              </td>
              <td className="p-4" data-id="element-245">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-246">
                  Gen 2
                </span>
              </td>
              <td className="p-4 text-gray-700" data-id="element-247">Legacy Gen 2 setups</td>
              <td className="p-4 text-sm text-gray-600" data-id="element-248">
                Older generation still relevant and required for events
                utilizing Gen 2 equipment.
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>;
}